import React, { useEffect, useRef } from 'react';
import { Icon } from '@pella/sash-framework';

const ToTop = () => {
	const toTopRef = useRef(null);

	useEffect(() => {
		window.addEventListener('scroll', onScrollEvent, { passive: true });
		return () => window.removeEventListener('scroll', onScrollEvent);
	}, []);

	const onScrollEvent = () => {
		if (window.scrollY > 1000) {
			toTopRef?.current?.classList.add('opacity-100');
			toTopRef?.current?.classList.remove('opacity-0', 'pointer-events-none');
		} else {
			toTopRef?.current?.classList.remove('opacity-100');
			toTopRef?.current?.classList.add('opacity-0', 'pointer-events-none');
		}
	};

	const onToTopClick = () => window.scrollTo({ top: 0, behavior: 'smooth' });

	return (
		<div
			ref={toTopRef}
			className='toTop pointer-events-none sticky bottom-0 z-10 mx-auto max-w-[1568px] px-6 opacity-0 transition-opacity md:px-8 xl:px-16 h-[0px]'
		>
			<button
				onClick={onToTopClick}
				className='toTopBtn ml-auto flex h-12 w-12 flex-col items-center justify-center bg-primary pb-1 text-white no-underline transition-colors hover:bg-primary/90 focus:bg-primary/90 absolute bottom-0 right-6 md:right-8 xl:right-16'
				aria-label='To Top'
			>
				<Icon
					name='keyboard_arrow_up'
					className='block'
				/>
				<span className='text-xs font-semibold uppercase leading-none tracking-wider'>Top</span>
			</button>
		</div>
	);
};

export default ToTop;
